import { render, staticRenderFns } from "./Voucher-Search.vue?vue&type=template&id=6b7166cb&scoped=true&"
import script from "./Voucher-Search.vue?vue&type=script&lang=js&"
export * from "./Voucher-Search.vue?vue&type=script&lang=js&"
import style0 from "./Voucher-Search.vue?vue&type=style&index=0&id=6b7166cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7166cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7166cb')) {
      api.createRecord('6b7166cb', component.options)
    } else {
      api.reload('6b7166cb', component.options)
    }
    module.hot.accept("./Voucher-Search.vue?vue&type=template&id=6b7166cb&scoped=true&", function () {
      api.rerender('6b7166cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VeK1bfkI509V/JS/comp/Voucher-Search.vue"
export default component.exports